export default __webpack_public_path__ + "img/Aws-Logo-660x330.04947b3c.png";